import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../store';
import Flex from '../../../uikit/Flex/Flex';
import { getFocus, isEmpty } from '../../../uikit/helper';
import Loader from '../../../uikit/Loader/Loader';
import Text from '../../../uikit/Text/Text';
import { applicantMessagesMiddleWare } from '../../applicantprofilemodule/store/middleware/applicantProfileMiddleware';
import { zitaPath } from '../../constValue';
import AppliedJobsTable from './AppliedJobsTable';
import styles from './candidatedashboardscreen.module.css';
import InvitedJobsTable from './InvitedJobsTable';
import Messages from './Messages';
import { dashBoardMiddleWare } from './store/middleware/dashboardmiddleware';
import UploadProfileCard from './UploadProfileCard';

type Props = {
  setjd_id?: (val: any) => void;
  isjd_id?: any;
  isnotificationdata?: any;
}
const CandidateDashBoardScreen = ({ setjd_id, isjd_id, isnotificationdata }: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const version = process.env.REACT_APP_VERSION;
  const [isLoader, setLoader] = useState(true);
  const [isJdId, setJdId] = useState('');
  const [isJobTitle, setJobTitle] = useState('');
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const jobId: any = query.get('jd_id');

  // initial api call for dashboard
  useEffect(() => {
    dispatch(dashBoardMiddleWare()).then((res) => {
      setLoader(false);
      if (!isEmpty(jobId)) {
        setJdId(jobId);
        dispatch(
          applicantMessagesMiddleWare({
            chatname: res.payload.chatname,
            jd_id: jobId,
          }),
        ).then(() => {
          dispatch(dashBoardMiddleWare());
        });
      }
    });
  }, []);

  // loop 5 sec once dashboard api and message api
  useEffect(() => {
    const interval = setInterval(() => {
      if (isLoader === false) {
        dispatch(dashBoardMiddleWare());
      }
      if (!isEmpty(isJdId)) {
        dispatch(applicantMessagesMiddleWare({ chatname, jd_id: isJdId })).then(
          () => {
            dispatch(dashBoardMiddleWare());
          },
        );
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isLoader, isJdId]);

  const {
    invites,
    applied_job,
    user_info,
    setting,
    chatname,
    message,
    company_detail,
    profile,
    merged_results
  } = useSelector(
    ({ dashboardReducers, applicantMessageReducers }: RootState) => {
      return {
        invites: dashboardReducers.invites,
        applied_job: dashboardReducers.applied_job,
        user_info: dashboardReducers.user_info,
        setting: dashboardReducers.setting,
        message: applicantMessageReducers.message,
        chatname: dashboardReducers.chatname,
        company_detail: dashboardReducers.company_detail,
        profile: dashboardReducers.profile,
        merged_results: dashboardReducers.merged_results,
      };
    },
  );

  const checkAppliedJobLength = applied_job && applied_job?.length !== 0;

  // open list chat box
  const hanldeOpenChat = (id: string) => {
    dispatch(applicantMessagesMiddleWare({ chatname, jd_id: id })).then(
      () => {
        dispatch(dashBoardMiddleWare());
      },
    );
    getFocus('message_top_bar');
    setJdId(id);
  };

  // useEffect function for updating the jd and message tab based on jd_id when click the notification.
  useEffect(() => {
    if (isjd_id !== null && isnotificationdata?.description?.toLowerCase() === 'candidatemessage') {
      if (applied_job && applied_job?.find(data => data?.jd_id_id === Number(isjd_id))) {
        setJobTitle(merged_results && merged_results?.find(data => data?.jd_id_id === Number(isjd_id))?.job_title)
        hanldeOpenChat(isjd_id);
        // setjd_id(null)
      }
      else {
        if (merged_results && merged_results?.find(data => data?.jd_id_id === Number(isjd_id))?.job_status !== "Inactive") {
          setJobTitle(merged_results && merged_results?.find(data => data?.jd_id_id === Number(isjd_id))?.job_title)
          hanldeOpenChat(isjd_id);
          // setjd_id(null)
        }
        else {
          // setjd_id(null)
          setJdId(null)
          setJobTitle('')
        }
      }
    }
    if (isjd_id !== null && isnotificationdata?.description?.toLowerCase() !== 'candidatemessage') {
      setjd_id(null)
      setJdId(null)
      setJobTitle('')
    }
  }, [isjd_id, isnotificationdata])

  const noValue = applied_job && applied_job?.length === 0 && invites && invites.length === 0;
  const recruiter_id_id: any = company_detail && company_detail.recruiter_id_id;

  if (isLoader) {
    return <Loader />;
  }

  return (
    <Flex>
    <Flex
      columnFlex
      className={styles.overAll}
      height={window.innerHeight - 75}
    >
      <Text bold size={20}>
        My Dashboard
      </Text>
      <UploadProfileCard user_info={user_info} profile={profile} />
      <Flex row marginTop={40}>
        <Flex columnFlex flex={7}>
          {checkAppliedJobLength && (
            <div style={{ marginBottom: 30 }}>
              <AppliedJobsTable
                applied_job={applied_job}
                setting={setting}
                hanldeOpenChat={hanldeOpenChat}
                setJobTitle={setJobTitle}
                isjd_id={isjd_id}
                setjd_id={setjd_id}
              />
            </div>
          )}
          <InvitedJobsTable
            invites={invites}
            setting={setting}
            hanldeOpenChat={hanldeOpenChat}
            setJobTitle={setJobTitle}
            isjd_id={isjd_id}
            setjd_id={setjd_id}
          />
        </Flex>
        <Flex flex={5}>
          <Messages
            isJobTitle={isJobTitle}
            showEmptyMessgae={noValue}
            chatname={chatname}
            jd_id={isJdId}
            message={message}
            recruiter_id_id={recruiter_id_id}
          />
        </Flex>
      </Flex>
    </Flex>
    <div  
         className={styles.footerstyle}
       >
         <Text
           bold
           color="theme"
          
           size={11}
           onClick={zitaPath}
           style={{
             cursor: 'pointer',
           }}
         >
           Powered by Zita.ai
         </Text>
          <div className={styles.pipestyles}></div>
         <Text style={{marginLeft:'10px'}} 
          color="theme"
          size={11}
         >App Version {version}</Text>
       </div>
    </Flex>
  );
};

export default CandidateDashBoardScreen;
